<youtube-player [videoId]="videoId"></youtube-player>